export const fetchStatisticFull = () => fetch(`/api/bot/phrase_usages_full`);
export const fetchStatistic = (start, end) =>
  fetch(`/api/bot/phrase_usages/?end_date=${end}&start_date=${start}`);
export const fetchPhraseList = () => fetch('/api/bot/phrases/');
